import { useBusinessInfo } from '~/lib/Queries';

export function getLastBusinessId() {
    return parseInt(localStorage.getItem('last-business-id'));
}

export function setLastBusinessId(id) {
    localStorage.setItem('last-business-id', id);
}

export function useFreeBusinessExceededLimits()
{
    const {data} = useBusinessInfo();
    const isExceeded = data?.maxClients && data?.clientUsage >= data?.maxClients;
    const overage = Math.max(0, (data?.clientUsage - data?.maxClients) || 0);

    return {
        isExceeded,
        overage,
    };
}
